/**
 * HAS THIS BROWSER BEEN TOLD "NO" ABOUT THE MICROPHONE?
 *
 * Asked only after a join has already failed, and only to choose which sentence a reader is shown.
 *
 * A reader who blocks the microphone cannot get into a room at all today: LiveKit answers
 * `could not establish pc connection` and nothing draws (`web/e2e/listen-live.spec.ts` reproduces
 * it with the permission as the only variable). Until that is fixed properly — a listener's token,
 * which needs a decision about what the mint is asked for — the product can at least stop saying
 * *"that did not work just now, try again in a moment"*, which is **false**: trying again changes
 * nothing whatsoever, and the one thing that would help is not mentioned.
 *
 * Defensive on purpose. `navigator.permissions` is not everywhere, `'microphone'` is not a name
 * every engine accepts, and Firefox has historically thrown for it — so anything other than a clear
 * "denied" means we do not know, and a reader who does not know gets the ordinary sentence rather
 * than a guess about their browser settings.
 */
export async function microphoneIsBlocked(): Promise<boolean> {
  try {
    const permissions = navigator.permissions as Permissions | undefined;
    if (!permissions || typeof permissions.query !== 'function') return false;
    /* `PermissionName` does not include 'microphone' in every lib.dom, and the string is what the
       platform actually accepts — so the query is built from a name this file owns. */
    const status = await permissions.query({ name: 'microphone' as PermissionName });
    return status.state === 'denied';
  } catch {
    return false;
  }
}
